module.exports = __webpack_public_path__ + "media/images/patterns/pattern-2-b02bb4c610f05b7714a2225f314eeae2.svg";